module.exports = __webpack_public_path__ + "static/media/kitchen.d1185c6f.jpg";